import { render } from "./ColumnSelector.vue?vue&type=template&id=2bef6f4c&scoped=true"
import script from "./ColumnSelector.vue?vue&type=script&lang=js"
export * from "./ColumnSelector.vue?vue&type=script&lang=js"

import "./ColumnSelector.vue?vue&type=style&index=0&id=2bef6f4c&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bef6f4c"]])

export default __exports__